<template>
    <div>

        <div v-if="loading" class="text-center">
            <i class="fa fa-circle-o-notch fa-spin"></i> Loading
        </div>
        <div v-else>
            <vue-headful :title="(jobsite.JobsiteId ? 'Edit Jobsite: ' + jobsite.JobsiteId : 'New Jobsite') + ' :: MeritEHS'"/>

            <h4 class="py-2 mb-4">
                <ol class="breadcrumb font-weight-bold m-0 d-block d-md-inline-block">
                    <li class="breadcrumb-item font-weight-light d-block d-md-inline-block">
                        <router-link :to="`/jobsites`">
                            <i class="fa fa-building"></i> Jobsites
                        </router-link>
                    </li>
                    <template v-if="JobsiteId">
                        <li class="breadcrumb-item font-weight-light d-block d-md-inline-block mt-md-0 mt-2">
                            <router-link :to="`/jobsites/view/${JobsiteId}`">
                                {{ jobsite.JobsiteName }}
                            </router-link>
                        </li>
                        <li class="breadcrumb-item active d-block d-md-inline-block mt-md-0 mt-2"><i class="fa fa-edit"></i> Edit</li>
                    </template>
                    <template v-else>
                        <li class="breadcrumb-item active d-block d-md-inline-block mt-md-0 mt-2"><i class="fa fa-plus"></i> New</li>
                    </template>
                    <li class="ml-3 d-none d-md-inline-block">
                        <button type="button" class="btn btn-sm btn-success" v-on:click="saveJobsite(this)" :disabled="saving">
                            <span v-if="JobsiteId">Update</span>
                            <span v-else>Create</span>
                            Jobsite
                        </button>
                    </li>
                </ol>
            </h4>

            <div class="d-block d-md-none mt-3 mb-3">
                <button type="button" class="btn btn-sm btn-success" v-on:click="saveJobsite(this)" :disabled="saving">
                    <span v-if="JobsiteId">Update</span>
                    <span v-else>Create</span>
                    Jobsite
                </button>
            </div>

            <div class="row mt-2">
                <div class="col-lg-8 col-md-10 col-sm-12">
                    <div class="card mb-3">
                        <div class="card-header">Jobsite Details</div>
                        <div class="card-body">
                            <div class="form-group row">
                                <label :class="{'col-lg-2 col-md-3 col-sm-4 col-form-label text-sm-right': true, 'text-danger': errors.client_id}">Client (Optional):</label>
                                <div class="col-sm-8">

                                    <b-form-select v-model="jobsite.client_id" :options="clientOptions" />

                                    <span v-if="errors.client_id" class="text-danger">
                                        <span v-for="error in errors.client_id">{{ error }}</span>
                                    </span>
                                </div>
                            </div>
                            <hr/>

                            <div class="form-group row">
                                <label :class="{'col-lg-2 col-md-3 col-sm-4 col-form-label text-sm-right': true, 'text-danger': errors.JobsiteName}">Jobsite Name: <i v-if="!jobsite.JobsiteName" class="fa fa-asterisk small text-danger"></i></label>
                                <div class="col-sm-8">
                                    <input type="text" name="JobsiteName" v-model="jobsite.JobsiteName" :class="{'form-control': true, 'is-invalid': errors.JobsiteName}" placeholder="Jobsite Name" />
                                    <span v-if="errors.JobsiteName" class="text-danger">
                                        <span v-for="error in errors.JobsiteName">{{ error }}</span>
                                    </span>
                                </div>
                            </div>
                            <div v-bind:class="{ 'form-group': true, 'has-error': errors.JobsiteNumber }" class="row">
                                <label :class="{'col-lg-2 col-md-3 col-sm-4 col-form-label text-sm-right': true, 'text-danger': errors.JobsiteNumber}">Jobsite Number <i v-if="!jobsite.JobsiteNumber" class="fa fa-asterisk small text-danger"></i></label>
                                <div class="col-sm-8">
                                    <input type="text" name="JobsiteNumber" v-model="jobsite.JobsiteNumber" :class="{'form-control': true, 'is-invalid': errors.JobsiteNumber}" placeholder="Jobsite Number" />

                                    <div v-if="!jobsite.JobsiteId && total_jobsites !== null" class="mt-1 mb-1">
                                        <b-form-checkbox v-model="use_suggested" :value="true" :unchecked-value="false" plain>
                                            <i class="fa fa-question-circle text-muted" :title="`Incremental number based on total jobsites records: ${total_jobsites}`"></i>
                                            <span class="text-muted">Use Suggested Jobsite#:</span>&nbsp;
                                            <span>{{ suggestedJobsiteNumber }}</span>
                                        </b-form-checkbox>
                                    </div>

                                    <span v-if="errors.JobsiteNumber" class="text-danger">
                                        <span v-for="error in errors.JobsiteNumber">{{ error }}</span>
                                    </span>
                                </div>
                            </div>
                            <div v-bind:class="{ 'form-group': true, 'has-error': errors.DivisionId }" class="row">
                                <label :class="{'col-lg-2 col-md-3 col-sm-4 col-form-label text-sm-right': true, 'text-danger': errors.DivisionId}">Division <i v-if="!jobsite.DivisionId" class="fa fa-asterisk small text-danger"></i></label>
                                <div class="col-sm-8">
                                    <select v-model="jobsite.DivisionId" :class="{'form-control': true, 'is-invalid': errors.DivisionId}">
                                        <option :value="null">-- Select a Division --</option>
                                        <option v-for="(value, key) in divisions" v-bind:value="key">
                                            {{ value }}
                                        </option>
                                    </select>
                                    <span v-if="errors.DivisionId" class="text-danger">
                                        <span v-for="error in errors.DivisionId">{{ error }}</span>
                                    </span>
                                </div>
                            </div>
                            <div v-bind:class="{ 'form-group': true, 'has-error': errors.IsActive }" class="row">
                                <label :class="{'col-lg-2 col-md-3 col-sm-4 col-form-label text-sm-right': true, 'text-danger': errors.IsActive}">Active</label>
                                <div class="col-sm-8">
                                    <b-form-checkbox v-model="jobsite.IsActive" :value="1" :unchecked-value="0" plain></b-form-checkbox>

                                    <span v-if="errors.IsActive" class="text-danger">
                                        <span v-for="error in errors.IsActive">{{ error }}</span>
                                    </span>
                                </div>
                            </div>
                            <div v-bind:class="{ 'form-group': true, 'has-error': errors.enable_guest_check_in }" class="row">
                                <label :class="{'col-lg-2 col-md-3 col-sm-4 col-form-label text-sm-right': true, 'text-danger': errors.enable_guest_check_in}">Guest Check In</label>
                                <div class="col-sm-8">
                                    <b-form-checkbox v-model="jobsite.enable_guest_check_in" :value="1" :unchecked-value="0" plain>
                                        Enabling this will allow non-employees to enter their name, company, and phone# to check into the jobsite.
                                    </b-form-checkbox>

                                    <span v-if="errors.enable_guest_check_in" class="text-danger">
                                        <span v-for="error in errors.enable_guest_check_in">{{ error }}</span>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="card mb-3">
                        <div class="card-header">Address</div>
                        <div class="card-body">
                            <div v-bind:class="{ 'form-group': true, 'has-error': errors.Address }" class="row">
                                <label :class="{'col-lg-2 col-md-3 col-sm-4 col-form-label text-sm-right': true, 'text-danger': errors.Address}">Address</label>
                                <div class="col-sm-8">
                                    <input type="text" name="Address" v-model="jobsite.Address" class="form-control" placeholder="Address" />
                                    <span v-if="errors.Address" class="text-danger">
                                        <span v-for="error in errors.Address">{{ error }}</span>
                                    </span>
                                </div>
                            </div>
                            <div v-bind:class="{ 'form-group': true, 'has-error': errors.Address2 }" class="row">
                                <label :class="{'col-lg-2 col-md-3 col-sm-4 col-form-label text-sm-right': true, 'text-danger': errors.Address2}">Address2</label>
                                <div class="col-sm-8">
                                    <input type="text" name="Address2" v-model="jobsite.Address2" class="form-control" placeholder="Address2" />
                                    <span v-if="errors.Address2" class="text-danger">
                                        <span v-for="error in errors.Address2">{{ error }}</span>
                                    </span>
                                </div>
                            </div>
                            <div v-bind:class="{ 'form-group': true, 'has-error': errors.City }" class="row">
                                <label :class="{'col-lg-2 col-md-3 col-sm-4 col-form-label text-sm-right': true, 'text-danger': errors.City}">City</label>
                                <div class="col-sm-8">
                                    <input type="text" name="City" v-model="jobsite.City" class="form-control" placeholder="City" />
                                    <span v-if="errors.City" class="text-danger">
                                        <span v-for="error in errors.City">{{ error }}</span>
                                    </span>
                                </div>
                            </div>
                            <div v-bind:class="{ 'form-group': true, 'has-error': errors.State }" class="row">
                                <label :class="{'col-lg-2 col-md-3 col-sm-4 col-form-label text-sm-right': true, 'text-danger': errors.State}">State</label>
                                <div class="col-sm-8">
                                    <input type="text" name="State" v-model="jobsite.State" class="form-control" placeholder="State" />
                                    <span v-if="errors.State" class="text-danger">
                                        <span v-for="error in errors.State">{{ error }}</span>
                                    </span>
                                </div>
                            </div>
                            <div v-bind:class="{ 'form-group': true, 'has-error': errors.Zip }" class="row">
                                <label :class="{'col-lg-2 col-md-3 col-sm-4 col-form-label text-sm-right': true, 'text-danger': errors.Zip}">Zip</label>
                                <div class="col-sm-8">
                                    <input type="text" name="Zip" v-model="jobsite.Zip" class="form-control" placeholder="Zip" />
                                    <span v-if="errors.Zip" class="text-danger">
                                        <span v-for="error in errors.Zip">{{ error }}</span>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="card mb-3">
                        <div class="card-header">Team</div>
                        <div class="card-body">
                            <div v-bind:class="{ 'form-group': true, 'has-error': errors.general_contractor }" class="row">
                                <label :class="{'col-lg-2 col-md-3 col-sm-4 col-form-label text-sm-right': true, 'text-danger': errors.general_contractor}">General Contractor:</label>
                                <div class="col-sm-8">
                                    <input type="text" name="general_contractor" v-model="jobsite.general_contractor" class="form-control" placeholder="Enter General Contractor" />

                                    <span v-if="errors.general_contractor" class="text-danger mt-2">
                                        <span v-for="error in errors.general_contractor">{{ error }}</span>
                                    </span>
                                </div>
                            </div>
                            <hr/>

                            <table class="table table-bordered table-sm" primary-key="EmployeeId">
                                <thead>
                                    <tr>
                                        <th>Employee</th>
                                        <th>Jobsite Role</th>
                                        <th><i class="fa fa-trash"></i></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(emp, i) in employees" :key="emp.EmployeeId">
                                        <td>
                                            <employee-select
                                                :selectedValues="renderEmployee(emp)"
                                                @vselected="setEmployee($event, i)"
                                                :hasError="errors['employees.'+i+'.EmployeeId'] ? true : false"
                                                :filters="{is_active: 1}" />

                                            <span v-if="errors['employees.'+i+'.EmployeeId']" class="text-danger mt-2">
                                                <span v-for="error in errors['employees.'+i+'.EmployeeId']">{{ error }}</span>
                                            </span>
                                        </td>
                                        <td>
                                            <b-form-input v-model="emp.jobsite_role" placeholder="Enter Jobsite Role (Project Manager, Superintendent, etc.)" />

                                            <span v-if="errors['employees.'+i+'.jobsite_role']" class="text-danger mt-2">
                                                <span v-for="error in errors['employees.'+i+'.jobsite_role']">{{ error }}</span>
                                            </span>
                                        </td>
                                        <td>
                                            <a href="javascript:void(0)" v-on:click="employees.splice(i, 1)">
                                                <i class="fa fa-trash text-danger"></i>
                                            </a>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td colspan="3" class="text-center">
                                            <a href="javascript:void(0)" style="padding: 4px 8px; border: 1px dashed #ccc; display: block;" v-on:click="employees.push({jobsite_role: '', EmployeeId: null})">
                                                <i class="fa fa-plus-circle text-success"></i> Add Employee
                                            </a>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>

                    <div class="card">
                        <div class="card-header">Notes</div>
                        <div class="card-body">
                            <div class="row form-group">
                                <label class="col-lg-2 col-md-3 col-form-label text-sm-right">Notes:</label>
                                <div class="col-md-9 col-sm-12">
                                    <vue-editor v-model="jobsite.Description" :editor-toolbar="this.$root.customVueEditorToolbar"></vue-editor>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <hr/>
            <button type="button" class="btn btn-success" v-on:click="saveJobsite(this)" :disabled="saving">
                <span v-if="JobsiteId">Update</span>
                <span v-else>Create</span>
                Jobsite
            </button>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                loading: true,
                saving: false,
                use_suggested: false,
                total_jobsites: null,
                JobsiteId: this.$route.params.id,
                jobsite: {},
                divisions: {},
                clients: [],
                employees: [],
                errors: {},
            }
        },

        watch: {
            use_suggested(newVal, oldVal){
                //Check for True
                if(newVal === true)
                {
                    //Set it
                    this.setSuggestedJobsiteNum();
                }
            },
        },

        computed: {

            clientOptions(){
                //Setup
                var options = [{value: null, text: '-- Select a Client --'}];

                //Loop
                for(var i = 0; i < this.clients.length; i++)
                {
                    options.push({value: this.clients[i].client_id, text: this.clients[i].client_name});
                }

                //Send options
                return options;
            },

            EmployeeValues(){
                //check for null
                if(!this.jobsite.project_manager_id)
                {
                    return null;
                }

                //Send it
                return {EmployeeId: this.jobsite.project_manager_id, FirstName: this.jobsite.pm_first_name, LastName: this.jobsite.pm_last_name, EmployeeNumber: this.jobsite.pm_employee_number};
            },

            suggestedJobsiteNumber(){
                //Check for subcontractor
                if(this.total_jobsites === null)
                {
                    return '';
                }

                //Build the Value
                var num = this.total_jobsites + 1 + '';

                //Process the LENGTH
                for(var i = num.length; i < 5; i++)
                {
                    //Prepend
                    num = '0' + num;
                }

                // //Check for Temp
                // if(this.employee.is_temp_employee == 1)
                // {
                //     num = 'T' + num;
                // }

                // //Check for Sub?
                // if(this.employee.subcontractor_id)
                // {
                //     num = 'S' + num;
                // }

                //Send it
                return num;
            }
        },

        methods: {
            //Get the Various Resources We Need to Edit a Jobsite
            getErrorClass(attribute) {
                return {
                    'form-group has-error': this.errors[attribute],
                    'form-group': !this.errors[attribute],
                }
            },

            getSuggestedValues(){
                //Get the data
                this.$http
                    .get('jobsites/suggested')
                    .then(response => {
                        //Set all the data
                        this.total_jobsites = response.data.total_jobsites;
                    })
                    .catch(response => {

                    });
            },

            getJobsite() {
                //Get the data
                this.$http
                    .get('jobsites/edit' + (this.JobsiteId ? '/' + this.JobsiteId : ''))
                    .then(response => {
                        //Set all the data
                        this.jobsite = response.data.jobsite;
                        this.divisions = response.data.divisions;
                        this.clients = response.data.clients;
                        this.employees = response.data.employees;

                        //IF there is only 1 jobsite, set the ID
                        if(!this.jobsite.JobsiteId && Object.keys(this.divisions).length === 1)
                        {
                            //set the First one
                            var keys = Object.keys(this.divisions);

                            //set it
                            this.jobsite.DivisionId = keys[0];
                        }

                        //Set loading
                        this.loading = false;
                    })
                    .catch(response => {

                    });
            },

            saveJobsite() {
                //SHow loading
                this.saving = true;

                //Reset the errors
                this.errors = {};

                //Delete the Jobsite Name because the API updates using name as well as ID
                delete this.jobsite.DivisionName;
                delete this.jobsite.division_code;

                //Set the employees
                this.jobsite.employees = this.employees;

                //Send it
                this.$http
                .post('jobsites/edit' + (this.JobsiteId ? '/' + this.JobsiteId : ''), this.jobsite)
                .then(response => {
                    //Alert the user?
                    this.$toastr.success('Jobsite Saved');

                    //Return to main list?
                    this.$router.push('/jobsites/view/' + response.data.JobsiteId);
                })
                .catch(error => {
                    //Check for error
                    if(error.response.status === 422)
                    {
                        //Display validation errors
                        this.errors = error.response.data
                    }
                })
                .then(response => {
                    //SHow loading
                    this.saving = false;
                });
            },

            setSuggestedJobsiteNum(){
                //IF the value is not set to true, do nothing
                if(!this.use_suggested)
                {
                    return;
                }

                //Set it
                this.jobsite.JobsiteNumber = this.suggestedJobsiteNumber;
            },

            setEmployee(employee, i){
                //Check for null
                if(!employee)
                {
                    //Clear it
                    this.employees[i].EmployeeId = null;

                    //Stop here
                    return;
                }

                //Set it
                this.employees[i] = {
                    EmployeeId: employee.EmployeeId,
                    FirstName: employee.FirstName,
                    LastName: employee.LastName,
                    EmployeeNumber: employee.EmployeeNumber,
                    jobsite_role: '',
                };

                //Force Update?
                this.$forceUpdate();
            },

            renderEmployee(emp){
                //Check fro ID
                if(!emp.EmployeeId)
                {
                    return;
                }

                //Send it
                return {
                    EmployeeId: emp.EmployeeId,
                    FirstName: emp.FirstName,
                    LastName: emp.LastName,
                    EmployeeNumber: emp.EmployeeNumber
                };
            },
        },

        mounted() {
            //Get the Jobsites
            this.getJobsite();

            //Check for an ID
            if(!this.jobsite.JobsiteId)
            {
                //Get the total
                this.getSuggestedValues();
            }
        }
    }
</script>
